import HotelsIcon, { DEFAULT_ICON_SIZE } from './src/HotelsIcon';

export { DEFAULT_ICON_SIZE };
export default HotelsIcon;
